export const fr = {
  title: 'Forêts primaires',
  subtitle: '30 m, tropiques, UMD/GLAD',
  download_data: 'https://glad.umd.edu/dataset/primary-forest-humid-tropics',
  learn_more: 'https://glad.umd.edu/dataset/primary-forest-humid-tropics',
  content: [
    {
      label: 'Fonction',
      value:
        "Cet ensemble de données permet de cartographier l'étendue des forêts primaires dans les régions pantropicales mondiales en 2001.",
    },
    {
      label: 'Résolution',
      value: '30 x 30 mètres',
    },
    {
      label: 'Couverture géographique',
      value: 'Pantropical',
    },
    {
      label: 'Source',
      value:
        'Turubanova, S., Potapov, P.V., Tyukavina, A. and Hansen, M.C., 2018. Ongoing primary forest loss in Brazil, Democratic Republic of the Congo, and Indonesia. Environmental Research Letters, 13(7), p.074028.',
    },
    {
      label: 'Date du contenu',
      value: 2001,
    },
  ],
  overview: {
    label: 'Aperçu',
    value:
      "Les forêts primaires figurent parmi les forêts les plus riches en biodiversité, fournissant une multitude de services écosystémiques, ce qui les rend cruciales pour le suivi de l'aménagement du territoire national et la comptabilisation du carbone. Cet ensemble de données définit les forêts primaires comme étant « un couvert forestier tropical humide naturel mature qui n'a pas été complètement défriché et reboisé dans l'histoire récente ». Les chercheurs ont classé les images Landsat en données sur les forêts primaires, en utilisant un algorithme distinct pour chaque région.",
  },
  citation: {
    label: 'Citation',
    value:
      'Turubanova, S., Potapov, P.V., Tyukavina, A. and Hansen, M.C., 2018. Ongoing primary forest loss in Brazil, Democratic Republic of the Congo, and Indonesia. Environmental Research Letters, 13(7), p.074028. Accessed through Global Forest Watch on 31/01/2025. www.globalforestwatch.org.',
  },
};
